import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  message: {
    id: 'Error.message',
    description: 'Form error message',
    defaultMessage: 'Obligatoriskt fält',
  },
});
